import { Container } from './Container';
import { Details } from './Details';
import { Summary } from './Summary';
export const ExpansionPanel = {
    Container,
    Details,
    Summary,
};
//# sourceMappingURL=index.js.map